import React from 'react';
import Button from '@material-ui/core/Button';

import { useStyles, useStylesRegularPrimary } from './styles';

function PrimaryButton({
  handleClick,
  text,
  isDisabledButton,
  isLoading,
  classesButton,
  endIcon,
  startIcon,
}) {
  const classes = useStyles();
  const classesRegularPrimary = useStylesRegularPrimary();

  return isLoading ? (
    <Button
      disabled={isDisabledButton}
      fullWidth
      onClick={handleClick}
      className={classes.button}
      classes={classesButton ? classesButton : classesRegularPrimary}
    >
      {text}
    </Button>
  ) : (
    <Button
      disabled={isDisabledButton}
      onClick={handleClick}
      className={classes.button}
      startIcon={startIcon}
      endIcon={endIcon}
      classes={classesButton ? classesButton : classesRegularPrimary}
    >
      {text}
    </Button>
  );
}

export default PrimaryButton;
